import { useReveal } from "@/hooks/useReveal";

const FOUNDER_IMAGE =
  "https://customer-assets.emergentagent.com/job_girl-activity-hub/artifacts/yfxrv8n6_FB_IMG_1783229554221.jpg";

export default function Story() {
  const leftRef = useReveal();
  const rightRef = useReveal();
  return (
    <section id="story" className="bg-[#F9F6F0] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div
          ref={leftRef}
          className="reveal lg:col-span-4 lg:sticky lg:top-28"
          data-testid="story-image"
        >
          <div className="relative max-w-[300px] mx-auto lg:mx-0">
            <div className="absolute -inset-3 border border-[#E8D7D0] rounded-[24px] rotate-2" />
            <div className="relative w-full aspect-[4/5] rounded-[20px] overflow-hidden border border-[#E8D7D0] bg-[#FFFDF9]">
              <img
                src={FOUNDER_IMAGE}
                alt="The Me Amor founder — a mother, on a mission"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="mt-4 flex items-center gap-3">
              <div className="h-px w-6 bg-[#C48B9F]" />
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#7D6B6D]">
                  Founder
                </div>
                <div className="font-serif-me italic text-lg text-[#36292A]">
                  A mother, on a mission
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={rightRef}
          className="reveal lg:col-span-8 lg:pl-8"
          data-testid="story-copy"
        >
          <span className="text-[11px] tracking-[0.3em] uppercase text-[#C48B9F]">
            Our Story
          </span>
          <h2 className="mt-4 font-serif-me text-4xl sm:text-5xl leading-[1.05] text-[#36292A]">
            The Heart Behind{" "}
            <em className="italic text-[#C48B9F] font-normal">Me Amor.</em>
          </h2>

          <div className="mt-8 space-y-5 text-[#36292A] leading-relaxed max-w-2xl text-[15px] sm:text-base">
            <p>
              The dream for Me Amor started with a simple, real-life problem:
              watching girls struggle with the anxiety, sensory stress, and
              fuss of hair wash days.
            </p>
            <p>
              As a mum, I wanted to create a solution. My ultimate goal was —
              and still is — to open the doors to{" "}
              <span className="font-serif-me italic text-[#C48B9F]">
                Me Amor Salon
              </span>
              , a physical, sensory-safe sanctuary where young girls can step
              in, sit in a professional styling chair, and feel completely
              pampered and celebrated without the stress.
            </p>
            <p>
              But building a physical salon takes time and capital. I didn&apos;t
              want to wait to start making an impact on these girls&apos;
              confidence.
            </p>
            <p>
              So, I pivoted. We are starting our journey right now with our
              curated subscription boxes. This allows us to begin working
              directly with girls aged 4 to 15 — helping them improve their
              self-esteem, learn about their hair, and embrace it as their
              crown. Through our styling tools, accessories, and interactive
              pen-pal letters, we are building a community of confident young
              women before our physical doors even open.
            </p>
            <p>
              Every single box you purchase today isn&apos;t just a gift for a
              young girl — it is a literal building block. Your support
              directly funds the opening of our future bricks-and-mortar
              salon.
            </p>
            <p>
              Thank you for being part of our village, supporting a
              mother&apos;s dream, and helping us teach the next generation to
              look in the mirror and say,{" "}
              <span className="font-serif-me italic text-[#C48B9F]">
                &ldquo;Me Amor&rdquo;
              </span>{" "}
              — I love myself.
            </p>
          </div>

          <div className="mt-10 flex items-center gap-4">
            <div className="h-px flex-1 max-w-[60px] bg-[#C48B9F]" />
            <span className="font-serif-me italic text-lg text-[#7D6B6D]">
              with love, the Me Amor family
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
